import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import * as moment from 'moment';

export class Invitation {
    public id: number = 0;
    public projectId: number = 0;
    public associationId?: number;
    public businessId?: number;
    public name?: string;
    public email?: string;
    public originApplicationId: number = 0;
    public originApplicationName?: string;
    public destinationApplicationId: number = 0;
    public destinationApplicationClientId?: string;
    public destinationApplicationName?: string;
    public destinationApplicationUri?: string;
    public acceptanceUrlFormat?: string;
    public createdUtc!: moment.Moment;
    public updatedUtc!: moment.Moment;

    public get lastSendedUtc(): moment.Moment | undefined {
        return this.updatedUtc ? this.updatedUtc : this.createdUtc;
    }

    public get lastSendedLocal(): string {
        return moment.utc(this.lastSendedUtc).local().format('DD/MM/YYYY HH:mm');
    }

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.UserInvitations;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    constructor(json?: any) {
        if (!json) {
            this.destinationApplicationId = -1;
            return;
        }

        Object.assign(this, json, {
            createdUtc: moment.utc(json.createdUtc),
            updatedUtc: moment.utc(json.updatedUtc),
        });

        if (!this.destinationApplicationId) {
            this.destinationApplicationId = -1;
        }
    }
}
